interface Props {
  color?: string;
}

function CloseIcon(props: Props) {
  const { color } = props;

  return (
    <svg width="18.57" height="18.57" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.2857 0.714294L0.714294 19.2857M0.714294 0.714294L19.2857 19.2857"
        stroke={color ?? "#007293"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CloseIcon;
